/**
 * UI scale for large displays at 100% OS scaling.
 * 4K @ 100% ≈ 3840 CSS px → 1.4 (matches “feels right at 140% Windows scaling”).
 * 4K @ 140% ≈ 2743 CSS px → 1.0 so we don't double-scale.
 */
export function chromeScale(): number {
  return window.innerWidth >= 3200 ? 1.4 : 1;
}

export function onChromeScaleChange(cb: () => void): void {
  let last = chromeScale();
  window.addEventListener('resize', () => {
    const next = chromeScale();
    if (next !== last) {
      last = next;
      cb();
    }
  });
}
